app.service('searchRelatedKeywordsCarousel', function (searchRelatedKeywordsApi, productsListConfig) {

	let $self;

	function init() {

		const {keyword} = productsListConfig.getData();
		if (!keyword) return;

		setElements();

		loadSearchRelatedKeywords(keyword)
			.then(response => {

				if (response.isEmpty) {
					$self.addClass('is-hidden');
					return;
				}

				$self.append(response.html);
				setUA();
			})
	}

	function loadSearchRelatedKeywords(keyword) {

		return searchRelatedKeywordsApi.get(keyword)
			.then(response => ({
				isEmpty: response.trim() === "",
				html: response
			}))
			.fail(() => {
				$self.addClass('is-hidden');
				console.error('[searchRelatedKeywordsCarousel] Błąd ładowania danych.');
			})
			.always(() => {
				$self.removeClass('loading');
			});
	}

	function setElements() {
		$self = $('#search-related-keywords');
	}

	function setUA() {
		$self.on('click', 'a', function () {
			UA.searchInteraction('Wyniki wyszukiwania', 'Klienci szukali rowniez', 'Klikniecie', $(this).text().trim());
		});
	}

	return {
		init
	};
});